import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
import router from '@/router';  // Asegúrate de ajustar la ruta según tu estructura de carpetas

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    filtradoNombres: [],
    usuarioGlobal: [],
    idDni: [],
    nombreUsers: "",
    cargo: "",
    correo: "",
    postulante: [],

    modal: false,
    moduloRapido: [],
    iconoModulo: [],
    plataformaRapida:[],
    contratosInicico:[],
    nombreTicka: "",
  },
  getters: {
    Modal(state) {
      return state.modal;
    },
    Items(state) {
      return state.filtradoNombres;
    },

    Users(state) {
      return state.usuarioGlobal;
    },

    DniEmpre(state) {
      return state.idDni;
    },
    Correo(state) {
      return state.correo;
    },
    Postulante(state) {
      return state.postulante;
    },

    NombresUsers(state) {
      return state.nombreUsers;
    },
    NombreTicka(state){
      return state.nombreTicka
    },


    Cargos(state) {
      return state.cargo;
    },

    ModuloRapido(state) {
      return state.moduloRapido;
    },

    IconoModulo(state) {
      return state.iconoModulo;
    },

    catPlataforma(state){
      return state.plataformaRapida
    },

    ListadoContratosInicio(state){
      return state.contratosInicico
    },

  },

  mutations: {
    llenarModal(state, data) {
      state.modal = data;
    },

    llenarItems(state, data) {
      state.filtradoNombres = data;
    },
    llenarUsuario(state, data) {
      state.usuarioGlobal = data;
    },
    llenarDni(state, data) {
      state.idDni = data;
    },

    llenarUsers(state, data) {
      state.nombreUsers = data;
    },
    NombreTicka(state,data){
      state.nombreTicka = data
    },

    llenarCargos(state, data) {
      state.cargo = data;
    },

    llenarCorreos(state, data) {
      state.correo = data;
    },

    llenarPostulante(state, data) {
      state.postulante = data;
    },
    llenarModulosRapido(state, data) {
      state.moduloRapido = data;
    },

    llenarIconoModulo(state, data) {
      state.iconoModulo = data;
    },

    llenarPlataforma(state, data){
      state.plataformaRapida = data
    },

    llenarContratosInicio(state,data){
      state.contratosInicico = data
    }

  },
  actions: {
    async getAttributes({ commit }) {
      const token = localStorage.getItem("access_token");
      const usuarioIngresado = localStorage.getItem("userId");

      try {
        axios
          .get(`Usuario/PermisosUsuario/${usuarioIngresado}`, {
            headers: { authorization: "Bearer " + token },
          })
          .then((datos) => {
            // console.log(datos);
            let nombreCompleto = `${datos.data[0].usuNombres}  ${datos.data[0].usuApePaterno} ${datos.data[0].usuApeMaterno}`;
            commit("llenarUsers", nombreCompleto);
            commit("NombreTicka",`${datos.data[0].usuNombres} ${datos.data[0].usuApePaterno}`);
            commit("llenarCargos", datos.data[0].cargo);
            commit("llenarCorreos", datos.data[0].correoUsu);
            commit("llenarModulosRapido", datos.data);
            localStorage.setItem("idEmpresaUsers", datos.data[0].idEmpresa)
            console.log(datos.data)
            localStorage.setItem("dniUsers", datos.data[0].usuDocumento);

            axios
              .get(`Empresa/EmpresaxTrabajador/${datos.data[0].usuDocumento}`)
              .then((r) => {
                commit("llenarDni", r.data);
                // console.log(r.data);
              });

            axios.get(`Contrato/ListarContratosyRen/${datos.data[0].usuDocumento}`).then((r)=>{
              commit("llenarContratosInicio",r.data)
             console.log(r.data)
            })

            let des = [];
            let iconoModulo = [];
            let postulante = [];
            let catPlataforma = []

            for (let itema of datos.data) {
              if (itema.catplataform == localStorage.getItem("catPlataforma") && localStorage.getItem('idPerfil')) {
                if (itema.modNombre == "POSTULANTE") {
                  postulante.push(itema.catNombre);
                  commit("llenarPostulante", postulante);
                  console.log("aqui" + postulante);
                }

                // console.log(itema.catplataform);
                catPlataforma.push(itema.catplataform);
                let catPlataformas = catPlataforma.filter((item, index) => {
                  return catPlataforma.indexOf(item) === index;
                });

                des.push(itema.modNombre);
                let result = des.filter((item, index) => {
                  return des.indexOf(item) === index;
                });

                iconoModulo.push(itema.desIconoModulo);
                let iconos = iconoModulo.filter((item, index) => {
                  return iconoModulo.indexOf(item) === index;
                });
                commit("llenarUsuario", datos.data);
                commit("llenarItems", result);
                commit("llenarIconoModulo", iconos);
                commit("llenarPlataforma" , catPlataformas)
                // console.log(iconos);
                // console.log(result);
                // console.log(catPlataformas)
                              console.log( "llego" + itema)

              }
            }
          })
          .catch((error) => {
            if (error.message == "Network Error") {
              commit("llenarModal", true);
              Swal.fire({
                title: "Tu sesión ha expirado",
                //  text: "You won't be able to revert this!",
                icon: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "VOLVER A LOGUEARSE",
              }).then((result) => {
                if (result.isConfirmed) {
                 
                  if(localStorage.getItem('idPerfil') == 11){

                    localStorage.clear(),
                    router.push("/loginPostulante")
                  }else{
                 
                    window.location.reload(true),
                    localStorage.clear()
                   
                }
                   
                  
                }
              });
            }

            if (error.response.status == 401) {
              commit("llenarModal", true);
              Swal.fire({
                title: "Tu sesión ha expirado",
                //  text: "You won't be able to revert this!",
                icon: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "VOLVER A LOGUEARSE",
              }).then((result) => {
                if (result.isConfirmed) {
                  if(localStorage.getItem('idPerfil') == 11){
                    localStorage.clear(),
                    router.push("/loginPostulante")
                  }else{
                 
                    window.location.reload(true),
                    localStorage.clear()
                   
                }
                 
                }

             
              });
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  modules: {},
};
